import { render, staticRenderFns } from "./AllProduk.vue?vue&type=template&id=3b8710bf&scoped=true&"
import script from "./AllProduk.vue?vue&type=script&lang=js&"
export * from "./AllProduk.vue?vue&type=script&lang=js&"
import style0 from "./AllProduk.vue?vue&type=style&index=0&id=3b8710bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8710bf",
  null
  
)

export default component.exports